__turbopack_context__.v({
  "baseProductImageContainer": "_2m_6sq_baseProductImageContainer",
  "borderRadiusLg": "_2m_6sq_borderRadiusLg",
  "borderRadiusMd": "_2m_6sq_borderRadiusMd",
  "hoverOverlay": "_2m_6sq_hoverOverlay",
  "overlay": "_2m_6sq_overlay",
  "placeholder": "_2m_6sq_placeholder",
  "portrait": "_2m_6sq_portrait",
  "productCardRoot": "_2m_6sq_productCardRoot",
  "productImageContainer": "_2m_6sq_productImageContainer",
  "productImageContainer__withHoverOverlay": "_2m_6sq_productImageContainer__withHoverOverlay" + " " + "_2m_6sq_baseProductImageContainer",
  "productImageContainer__withoutHoverOverlay": "_2m_6sq_productImageContainer__withoutHoverOverlay" + " " + "_2m_6sq_baseProductImageContainer",
  "square": "_2m_6sq_square",
});
